import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import CampaignJoinPage from "@/app/CampaignJoinPage";

const joinSearchSchema = z.object({
  code: z.string().optional(),
});

export const Route = createFileRoute("/campaign/$shortId/join")({
  validateSearch: joinSearchSchema,
  component: CampaignJoinPage,
});
